<script>
import UserListVue from '@/app/users/UserList.vue';
import DataTableCpfCnpjColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCpfCnpjColumn.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';

export default {
  name: 'NotificationUserList',
  extends: UserListVue,
  data: () => ({
    showExpand: false,
    hideEdit: true,
    hideDelete: true,
    selectRows: true,
    headers: [
      {
        text: 'Código',
        value: 'id',
      },
      {
        text: 'Nome',
        value: 'username',
      },
      {
        text: 'Documento',
        value: 'document',
        component: DataTableCpfCnpjColumnVue,
      },
      {
        text: 'Último atualização',
        value: 'updatedAt',
        component: DataTableDateColumnVue,
      },
    ],
  }),
  methods: {
    prepareRequest(params = {}) {
      return this.requestClass.list({
        System: 0,
        ...params,
      });
    },
    mapItemMethod(item = {}) {
      return {
        id: this.getUserSystemId(item),
        username: item.name,
        document: item.username,
        updatedAt: item.updatedAt,
      };
    },
    getUserSystemId(item = {}) {
      const user = item.userSystems.find(
        (u) => u.system === 'ContaCard',
      );

      if (user) {
        return user.id;
      }

      return '';
    },
    setUserListChecked() {
      this.$root.$on('set-notifications-list', (ids = []) => {
        this.$nextTick(
          () => {
            this.selectedRows = this.selectedRows.map(
              (item) => {
                if (ids.includes(item.row.id)) {
                  return {
                    value: true,
                    row: item.row,
                  };
                }
                return item;
              },
            );
          },
        );
      });
    },
  },
};
</script>
